export const BASE_URL = "https://speechbotlive.fintra.ai";
// export const BASE_URL = "http://18.143.16.145:8888/api/v1";
// Old URL
// "http://18.143.16.145:8888/api/v1";
